<template>
    <div class="bg-light pb-2 overflow-auto h-100">
        <header class="p-3 bg-white d-flex flex-column mb-2">
            <h5 class="m-0 fw-700">Search Results for <small class="small text-danger">"{{$route.query.s}}"</small></h5>
        </header>
        <div class="row g-2 row-cols-1 m-0">
            <div class="col" v-if="data.length > 0 && !data_loading">
                <div class="card card-body border-0" v-for="(result, index) in data" :key="index">
                    <router-link class="text-primary fw-600" :to="`/vikipedia/${result.ref}?content=${result.id}`">{{result.name}}</router-link>
                    <router-link class="text-muted text-decoration-underline" :to="`/vikipedia/${result.ref}`">Vikipedia/{{result.parent}}</router-link>
                </div>
            </div>
            <div class="col" v-else-if="data_loading">
                <div class=" d-flex flex-column">
                    <div class="shimmer mb-2" style="height: 50px;"></div>
                    <div class="shimmer mb-2" style="height: 50px;"></div>
                    <div class="shimmer mb-2" style="height: 50px;"></div>
                    <div class="shimmer mb-2" style="height: 50px;"></div>
                </div>
            </div>
            <div class="col p-4" v-else>
                <h6 class="text-muted opacity-6">No search results</h6>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
           data: [],
           data_loading: true 
        }
    },
    methods: {
        async loadSearch() {
            this.data_loading = true;
            await this.$axios.get(`/search/${this.$route.query.s}`)
                    .then((res) => {
                        this.data = res.data;
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
            this.data_loading = false;
        }
    },
    mounted() {
        this.loadSearch();
    },
    watch: {
        "$route": function(n) {
            if(n.name.includes('search') && n.query.s !== undefined) {
                if(n.query.s.toString().length > 3) this.loadSearch();
                else  this.$router.push('/');
            }        
        }
    }
}
</script>

<style scoped>
.text-primary {
    color: var(--primary-color) !important;
}

th:first-child {
    text-align: left;
}

td, th {
    vertical-align: middle;
    text-align: right;
}

.table>:not(:last-child)>:last-child>* {
    border-bottom-color: #ececec;
}

.card {
    margin-bottom: 10px;
}
</style>